import { Button as ButtonBase } from "./Button";
import { ButtonGroup } from "./ButtonGroup";

/**
 * `Button.Group` wie bei Antd; eigene Datei, damit `Button.tsx` nur Komponenten exportiert.
 * `settingsListRole` lässt die Shared-Liste den Kit-Knopf wie Antd `Button` behandeln
 * (Kompaktdarstellung nur mit Symbol, Zählung der Aktionen).
 */
export const Button = Object.assign(ButtonBase, { Group: ButtonGroup, settingsListRole: "button" as const });
